import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  disabledPeoples: [],
  allDisabledPeoples: [],
  totalPages: 0,
  totalRecords: 0,
  disabledPeople: null,
  errorStatus: null,
  disabledPeopleDetail: null,
};
const getters = {
  getApiLoad_20: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_DisabledPeoples(state, disabledPeoples) {
    state.disabledPeoples = disabledPeoples.items;
    state.totalPages = disabledPeoples.totalPages;
    state.totalRecords = disabledPeoples?.totalRecords ?? 0;
  },
  SET_AllDisabledPeoples(state, disabledPeoples) {
    state.allDisabledPeoples = disabledPeoples;
  },
  SET_DisabledPeople(state, disabledPeople) {
    state.disabledPeople = disabledPeople;
  },
  SET_DisabledPeopleDetail(state, disabledPeople) {
    state.disabledPeopleDetail = disabledPeople;
  },
};
const actions = {
  errorDisabledPeople({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getAllDisabledPeoples({ commit, dispatch, rootState }) {
    return apiClient
      .get('/DisabledPeople/All', {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_AllDisabledPeoples', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDisabledPeople', error);
      });
  },
  getDisabledPeoplesWithPagination(
    { commit, dispatch, rootState },
    { pageNumber, pageSize, fullName, nationalCode, mainPhoneNumber, cityId },
  ) {
    var url = '/DisabledPeople/AllPagination?pageNumber=' + pageNumber + '&pageSize=' + pageSize;
    if (fullName) {
      url += '&FullName=' + fullName;
    }
    if (nationalCode) {
      url += '&NationalCode=' + nationalCode;
    }
    if (mainPhoneNumber) {
      url += '&MainPhoneNumber=' + mainPhoneNumber;
    }
    if (cityId) {
      url += '&CityId=' + cityId;
    }
    return apiClient
      .get(url, { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } })
      .then((response) => {
        commit('SET_DisabledPeoples', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDisabledPeople', error);
      });
  },
  addDisabledPeople({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/DisabledPeople', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDisabledPeople', error);
      });
  },
  getDisabledPeople({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/DisabledPeople/ById?disabledPersonId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_DisabledPeople', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDisabledPeople', error);
      });
  },
  getDisabledPeopleDetail({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/DisabledPeople/ByIdWithDetails?disabledPersonId=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_DisabledPeopleDetail', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDisabledPeople', error);
      });
  },
  editDisabledPeople({ commit, dispatch, rootState }, data) {
    return apiClient
      .post('/DisabledPeople/Edit', data, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDisabledPeople', error);
      });
  },
  deleteDisabledPeople({ commit, dispatch, rootState }, id) {
    return apiClient
      .post(
        '/DisabledPeople/Remove?disabledPersonId=' + id,
        {},
        { headers: { 'X-CSRF-Token': rootState.loginModule.csrf } },
      )
      .then(() => {
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorDisabledPeople', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
